var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dummy-html"}},[_c('h5',{staticClass:"mb-3"},[_vm._v("\n    "+_vm._s(_vm.dataComponent.name)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"wrap-html",domProps:{"innerHTML":_vm._s(_vm.decodeHtmlEntities(JSON.parse(_vm.dataComponent.info).html))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1927954c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyHtml.vue
// module id = null
// module chunks = 